import React, {useState, useReducer} from 'react'
import { Grid,ButtonGroup, Button, Card, CardContent} from '@material-ui/core'
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import useStyles from '../Styles'
import Resume from './Resume'
import Portfolio from './Portfolio'
import Contact from './Contact'
import Header from './Header'

export default function MainContent(){
    const [current, setCurrent] = useState('Resume');
    const useStyle = useStyles();
    const ChangeState = (newState)=> {
      setCurrent(newState);
    }
    function renderSwitch(page){
        switch(page){
            case 'Resume':
                return <Resume />
            case 'Portfolio':
                return <Portfolio />
            case 'Contact':
                return <Contact />
        };
    }
    return(
        <Grid container direction='column' wrap='nowrap' spacing={3} className={useStyle.mainContent}>
          <Header HeaderStyle={useStyle.menu} setCurrent={ChangeState}/>
          <Grid item className={useStyle.content}> 
            <Card raised>
              <CardContent>
                {renderSwitch(current)}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
    )
}